<template lang="pug">
.vprPage
  router-view
</template>

<script>
import ChildVprController from '@/controllers/ChildVpr/ChildVprController'
import { provide } from 'vue'
import { useRoute } from 'vue-router'
export default {
  setup () {
    const controller = ChildVprController()
    const route = useRoute()
    const vprId = route.params.id
    controller.setVprId(vprId)
    provide('controller', controller)
  }
}
</script>
